import { Component, ViewEncapsulation } from '@angular/core';
import { UpdatePendingNewsRequest } from '../DTOs/update-pending-news-request';
import { PendingNewsService } from '../pending-news.service';
import { UIBlockingService } from '../../core/ui-blocking.service';
import { ToastNotificationService } from '../../core/toast-notification.service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute, Router } from '@angular/router';
import { PendingNewsInfo } from '../DTOs/pending-news-info';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-edit-news-article-modal',
  templateUrl: './edit-news-article-modal.component.html',
  encapsulation: ViewEncapsulation.None
})
export class EditNewsArticleModalComponent {

    constructor(private pendingNewsService: PendingNewsService
        , private blockUI: UIBlockingService
        , private notificationService: ToastNotificationService
        , private activeModal: NgbActiveModal) { }

    newsInfo: PendingNewsInfo;
    imageFile: File = null;
    maxMainImageSize = 500000000; // 500 MB

    ngOnInit() {
    }

    dismiss(): void {
        this.activeModal.dismiss();
    }

    update() {
        if (this.imageFile != null) {
            this.blockUI.start();
            this.UploadNewImage().subscribe({
                next: (data) => {
                    this.UpdateNews(data);
                },
                error: (err) => {
                    this.notificationService.error(err.error.message);
                    this.blockUI.stop();
                },
            });
        }
        else {
            this.blockUI.start();
            this.UpdateNews(null);
        }
    }

    updateImage(files: FileList) {
        var file = files.item(0);
        if (!file.type.includes("image")) {
            this.notificationService.error(file.name + " must be an image file.");
            return;
        }
        if (file.size > this.maxMainImageSize) {
            this.notificationService.error(file.name + " is larger than the maximum file size.");
            return;
        }
        this.imageFile = file;
    }

    UploadNewImage() {
        const uploadData = new FormData();
        if (this.imageFile != null) {
            uploadData.append('mainImage', this.imageFile, this.imageFile.name);
        }
        return this.pendingNewsService.uploadNewImage(uploadData);
    }

    UpdateNews(imageId) {
        const req = new UpdatePendingNewsRequest();
        req.ArticleId = this.newsInfo.newsId;
        req.ArticleContent = this.newsInfo.articleContent;
        req.ImageId = imageId;
        req.ArticleTitle = this.newsInfo.articleTitle;
        req.RunDate = this.newsInfo.runDate;
        this.pendingNewsService.updateNews(req).subscribe({
            next: (data) => {
            },
            error: (err) => {
                this.notificationService.error(err.error.message);
                this.blockUI.stop();
                console.log(err)
            },
            complete: () => {
                this.blockUI.stop();
                this.notificationService.success("Article successfully updated.");
                this.activeModal.close();
            }
        });
    }

}
